import React from 'react';
import { Row } from 'reactstrap';
import {
  Control,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { SurveySection } from '../../../../../../entities/survey_engine/SurveySection';
import { SurveyQuestion } from '../../../../../../entities/survey_engine/SurveyQuestion';
import { FormFieldHeader } from '../../../../../../components/FormFieldHeader';
import { QuestionInput } from './QuestionInput';

interface PropTypes {
  section: SurveySection;
  previewMode: boolean;
  formRegister: UseFormRegister<any>;
  control?: Control<any, any>;
  getValues?: UseFormGetValues<any>;
  setValue?: UseFormSetValue<any>;
}

export function ApplicationFormSection(props: PropTypes) {
  return (
    <div key={props.section.id}>
      <h3 className='py-3 my-0'>{props.section.sectionName}</h3>
      {props.section.questions.map((question: SurveyQuestion) => {
        return (
          <Row
            key={`${props.section.id}-${question.id}`}
            className='mx-0 mb-3 fs-5 fw-semibold'
          >
            <FormFieldHeader
              fieldName={question.title}
              isRequired={question.mandatory}
              classNames={'px-0 mb-1'}
            />
            <QuestionInput
              question={question}
              disabled={props.previewMode}
              formRegister={props.formRegister}
              getValues={props.getValues}
              setValue={props.setValue}
              control={props.control}
            />
          </Row>
        );
      })}
    </div>
  );
}
